import { createSlice } from 'ngrx-slice';

export interface State {
  ageVerified: false;
}

export const initialState: State = {
  ageVerified: false,
};

export const {
  actions: AgeVerificationActions,
  selectors,
  ...AgeVerificationFeature
} = createSlice({
  name: 'age-verified',
  initialState,
  reducers: {
    verifyAge: (state: State) => {
      return {
        ...state,
        ageVerified: true,
      };
    },
  },
});

export const AgeVerificationSelectors = {
  ...selectors,
};
